import type { FeatureKey } from '@trellis/shared'

import { isFeatureEnabled, useFeatureFlags } from './useFeatureFlags'

/** Hook that checks a single feature flag, encapsulating the query + lookup. */
export function useIsFeatureEnabled(key: FeatureKey) {
  const { data: featureToggles, isPending } = useFeatureFlags()

  return {
    isEnabled: isFeatureEnabled(featureToggles, key),
    isPending,
  }
}
